module.exports = __webpack_public_path__ + "img/activity-1-zh.953bd259.png";